const styleSheet = () => ({
  alignVerticalTop: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  container: {
    width: '100%',
    display: 'flex',
    color: '#051D39',
    marginBottom: '1rem',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontSize: '32px',
    width: '310px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    height: '41px',
    fontWeight: 700,
    lineHeight: '41px',
    paddingRight: '1rem',
  },
  desc: {
    fontSize: '14px',
    color: ' #6373A4',
    textTransform: 'capitalize',
    fontFamily: "'Museo Sans', sans-serif",
    height: '19px',
    fontWeight: '500',
    lineHeight: '19px',
  },
  notAvailable: {
    height: '19px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: '500',
    lineHeight: '19px',
    fontSize: '14px',
    textAlign: 'left',
    textTransform: 'capitalize',
  },
  sectionName: {
    height: '13px',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
    lineHeight: '13px',
    fontSize: '10px',
    textTransform: 'uppercase',
    color: '#6373A4',
  },
  relativeEngagement: {
    width: '100%',
    cursor: 'pointer',
  },
  lastActivityDates: {
    height: '19px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '19px',
  },
  rowMarginTopRow: {
    marginTop: '1.4em',
    marginBottom: '10px',
  },
  datesRowMarginTopRow: {
    marginTop: '1.4em',
    marginBottom: '8px',
  },
  end: {
    // This will only work with another class that has display:flex
    justifyContent: 'flex-end',
  },
  col1: {
    width: '375px',
  },
  col2: {
    width: '330px',
    paddingLeft: '66px',
  },
  col3: {
    width: '207px',
    marginRight: '35px',
  },
  col4: {
    width: '229px',
  },
});

export default styleSheet;
